var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "requiring-user",
    [
      _c("h1", { staticClass: "page-title" }, [
        _vm._v(_vm._s(_vm.$t("blackboard.title")))
      ]),
      _vm._v(" "),
      _vm._l(_vm.projects, function(project) {
        return _c(
          "form-container",
          { key: project.id, attrs: { size: "medium" } },
          [
            _c(
              "ul",
              { staticClass: "project-list" },
              [
                _c("h2", { staticClass: "project__title" }, [
                  _vm._v(_vm._s(project.name))
                ]),
                _vm._v(" "),
                _c("hr", { staticClass: "project__separator" }),
                _vm._v(" "),
                _vm._l(project.documents, function(doc) {
                  return _c("li", { key: doc.id, staticClass: "document" }, [
                    _c(
                      "a",
                      {
                        staticClass: "link",
                        attrs: { href: doc.url, target: "_blank" }
                      },
                      [
                        _c("div", { staticClass: "title" }, [
                          doc.path && doc.path.length > 0
                            ? _c(
                                "div",
                                { staticClass: "path" },
                                _vm._l(doc.path, function(segment, index) {
                                  return _c(
                                    "span",
                                    { key: segment },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(segment) +
                                          "\n                "
                                      ),
                                      index != doc.path.length - 1
                                        ? _c("icon", {
                                            staticClass: "path-separator",
                                            attrs: { name: "caret-right" }
                                          })
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                })
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", { staticClass: "name" }, [
                            _vm._v(_vm._s(doc.name))
                          ]),
                          _vm._v(" "),
                          doc.description
                            ? _c("div", { staticClass: "description" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(doc.description) +
                                    "\n            "
                                )
                              ])
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("span", { staticClass: "open" }, [
                          _vm._v(_vm._s(_vm.$t("blackboard.performShow")))
                        ])
                      ]
                    )
                  ])
                })
              ],
              2
            )
          ]
        )
      }),
      _vm._v(" "),
      _vm.isLoading || _vm.errorMsg
        ? _c(
            "form-container",
            { attrs: { size: "medium" } },
            [
              _vm.isLoading ? _c("loading-indicator") : _vm._e(),
              _vm._v(" "),
              _vm.errorMsg
                ? _c("b-alert", { attrs: { variant: "danger", show: "" } }, [
                    _vm._v(_vm._s(_vm.errorMsg))
                  ])
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ea9af7a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ea9af7a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BlackboardScreen.vue
// module id = null
// module chunks = 